import React, { Component } from 'react'
import { Icon, Message } from 'semantic-ui-react'
import Dropzone from 'react-dropzone'

class Upload extends Component {
  constructor (props) {
    super(props)

    this.state = {
      error: null,
      types: 'application/zip, application/msword, application/pdf, image/jpeg, image/png, image/svg+xml, audio/mpeg, audio/mp3'
    }
  }

  handleDropRejected = (files, event) => {
    const errorFiles = []
    for (let file of files) {
      errorFiles.push(file.name)
    }

    this.setState({
      error: {
        files: errorFiles
      }
    })
  }

  render () {
    const { dropzone, onDrop } = this.props
    let errorFiles = null

    if (this.state.error) {
      errorFiles = this.state.error.files.map((file, i) => <li key={i}>{file}</li>)
    }

    return (
      <div>
        <Dropzone accept={this.state.types} onDropAccepted={onDrop} onDropRejected={this.handleDropRejected} style={styles.dropzone} activeStyle={styles.dropzoneActive} maxSize={10485760}>
          <p>Essayez de déposer quelques fichiers ici, ou cliquez pour sélectionner les fichiers à télécharger.</p>
          <Icon name='cloud upload'/>
        </Dropzone>
        {
          errorFiles &&
          <Message negative>
            <Message.Header>Erreur</Message.Header>
            <p>Les fichiers suivants ont été refusés :</p>
            <ul>{errorFiles}</ul>
          </Message>
        }
        { dropzone.files && dropzone.files.length > 0 &&
          <Message success>
            <Message.Header>Succès</Message.Header>
            <p>Les fichiers suivants ont été chargés :</p>
            <ul>
              {dropzone.files.map(f => <li key={f.name}>{f.name} - {f.size} bytes</li>)}
            </ul>
          </Message>
        }
      </div>
    )
  }
}

// Define stylesheet for Dropzone
const styles = {
  dropzone: {
    borderColor: '#666666',
    borderRadius: '5px',
    borderStyle: 'dashed',
    borderWidth: '2px',
    height: '200px',
    padding: '90px 10px 10px',
    textAlign: 'center',
    width: '100%'
  },
  dropzoneActive: {
    borderColor: '#3498db'
  }
}

export default Upload



// WEBPACK FOOTER //
// ./src/components/list/media/upload.js